import { render, staticRenderFns } from "./dispatch2dy.vue?vue&type=template&id=021c89ba&scoped=true"
import script from "./dispatch2dy.vue?vue&type=script&lang=js"
export * from "./dispatch2dy.vue?vue&type=script&lang=js"
import style0 from "./dispatch2dy.vue?vue&type=style&index=0&id=021c89ba&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c89ba",
  null
  
)

export default component.exports